import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CoachProductsPage } from "src/pages/CoachProductsPage";
import { productsQueryOptions } from "src/queries/products";

const routeSearchSchema = z.object({
  tab: z.enum(["active", "archived"]).optional(),
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
});

export const Route = createFileRoute("/_auth/_coach/products/_tabs/")({
  component: CoachProductsPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  loaderDeps: ({ search }) => {
    return search;
  },
  async loader({ context, deps }) {
    return context.queryClient.query({
      ...productsQueryOptions(deps),
      staleTime: "static",
    });
  },
});
